import { WebsiteSessions } from 'app/people/people';

export class CustomizeFilterSelection {
  // TODO: RENAME
  countryCodes: CustomFilterProperty[];
  campaigns: CustomFilterProperty[];
  notcampaigns: CustomFilterProperty[];
  goals: CustomFilterProperty[];
  notGoals: CustomFilterProperty[];
  visitedPages: CustomFilterProperty[];
  labels: CustomFilterProperty[];
  profilings: CustomFilterProperty[];
  previousVisits: WebsiteSessions;
  consentVersions: PartialQueryConfiguration<string[]>;
  acceptedVersions: PartialQueryConfiguration<string[]>;
}

export class Selections extends CustomizeFilterSelection {
  name: string;
  displayName: string;
  isDefault: boolean;
  sortOrder: string;
  options: CustomFilterProperty[];
  source: string;
  dateRange: DateRangePickerDates;
  dateFormatted: string;
  dateSelection: string;
}

export class CustomFilterPropertyGeneric<T> {
  id: T;
  displayName: string;

  public set(id: T, displayName: string): CustomFilterPropertyGeneric<T> {
    this.id = id;
    this.displayName = displayName;
    return this;
  }
}

export class CustomFilterProperty extends CustomFilterPropertyGeneric<string> {}

export class DateRangePickerDates {
  startDate: string;
  endDate: string;
}

export class Operator extends CustomFilterPropertyGeneric<number> {
  // id = TriggerConditions enum-number
  constructor(id: number, displayName) {
    super();
    this.id = id;
    this.displayName = displayName;
  }
}

export class PartialQueryConfiguration<T> {
  // TODO: Rename
  operator: number;
  value: T;
}

export class PartialQueryStringConfiguration extends PartialQueryConfiguration<string> {
  constructor(operator: number, value: string) {
    super();
    this.operator = operator;
    this.value = value;
  }
}
